var map = {
	"./en.json": "4ap1",
	"./fr.json": "irhS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lqfw";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/masters [A-Za-z0-9-_,\s]+\.json$/
// module id = lqfw
// module chunks = 1